import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function TooltipHover({taskName, comments}: any) {
  const renderTooltip = (props:any) => (
    <Tooltip id="button-tooltip" {...props}>
        <div dangerouslySetInnerHTML={{ __html: comments }} style={{fontSize:'16px', padding:'4px'}} />
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="left"
      delay={{ show: 350, hide: 400 }}
      overlay={renderTooltip}
    >
      <p>{taskName}</p>
    </OverlayTrigger>
  );
}

export default TooltipHover;